module.exports = __webpack_public_path__ + "img/zizhizhengshu.83187672.png";